import React, { useState, useEffect } from "react"
import { AnimatePresence, motion, useReducedMotion } from "framer-motion"
import Menu from "./Menu"
import CategoryFilter from "./CategoryFilter"
import Footer from "./Footer"
import "../styles/main.css"
import * as talentStyles from "../styles/components/Talent.module.css"

const PageTransition = ({ children, path, pageContext: { isCategoryPage, isTalentPage, title } }) => {
  const shouldReduceMotion = useReducedMotion()

  const [menuState, setMenuState] = useState()
  const [showFooter, setShowFooter] = useState(false)
  const [talentInitMomentCompleted, setTalentInitMomentCompleted] = useState()
  const [colourString, setColourString] = useState()

  const overlayColours = ["velvetRed", "pistachioGreen", "fadedLavender"]

  useEffect(() => {
    setShowFooter(path !== "/")
  }, [path])

  useEffect(() => {
    // This will set the state of the talent moment completion to false 
    // both when we enter and leave the talent page, which is fine.
    setTalentInitMomentCompleted(false)

    if(isTalentPage) {
      setColourString(overlayColours[Math.floor(Math.random() * overlayColours.length)])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTalentPage])

  return (
    <>
    <a href="#main-content" style={{ position: 'absolute', left: '-9999px', top: 'auto', width: '1px', height: '1px', overflow: 'hidden',}}
  onFocus={(e) => {
    e.target.style.left = '16px'
    e.target.style.top = '16px'
    e.target.style.width = 'auto'
    e.target.style.height = 'auto'
    e.target.style.overflow = 'visible'
    e.target.style.zIndex = '9999'
    e.target.style.background = 'var(--chalk-board-black)'
    e.target.style.color = 'var(--paper-white)'
    e.target.style.padding = '8px 16px'
  }}
  onBlur={(e) => {
    e.target.style.left = '-9999px'
  }}
>
  Skip to main content
</a>
      <Menu path={path} menuState={menuState} setMenuState={setMenuState} isCategoryPage={isCategoryPage} isTalentPage={isTalentPage} />

      <AnimatePresence>{isCategoryPage && <CategoryFilter path={path} menuState={menuState} isTalentPage={isTalentPage} />}</AnimatePresence>

      <AnimatePresence>
        {isTalentPage && !talentInitMomentCompleted && (
          <motion.div
            key="overlay"
            className={`${talentStyles.overlay} ${talentStyles[colourString]}`}
            initial={{ y: "100%" }}
            animate={{
              y: 0,
              transition: {
                type: "tween",
                duration: 1,
              },
            }}
            exit={{
              y: "100%",
              transition: {
                type: "tween",
                duration: 1,
                delay: 1.5,
              },
            }}
            onClick={() => setTalentInitMomentCompleted(true)}
          >
            <motion.div
              className={talentStyles.overlayInner}
              initial={{ opacity: 0 }}
              animate={{
                opacity: 1,
                transition: {
                  delay: 1,
                },
              }}
              onAnimationComplete={(def) => {
                if (def.opacity === 1) {
                  setTalentInitMomentCompleted(true)
                }
              }}
              exit={{ opacity: 0, transition: { delay: 1 } }}
            >
              {title}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence mode="wait">{children}</AnimatePresence>
      {showFooter && <Footer />}
    </>
  )
}

export default PageTransition
